@use 'sass:map';
@use '../../variables' as *;
@use 'common/assets/scss/global' as *;
@import '@fortawesome/fontawesome-svg-core/styles.css';

@mixin input {
  position: absolute;
  opacity: 0;

  ~ label {
    border-radius: 10px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    row-gap: 4px;
    width: 100%;
    height: 100%;
    min-height: 100px;
    font-size: var(--#{$prefix}font-size-xs);
    cursor: pointer;
  }

  &:hover ~ label,
  &:focus-visible ~ label {
    outline: 2px solid var(--#{$prefix}primary);
    box-shadow: var(--#{$prefix}shadow-hover) HEXToRGBA(var(--#{$prefix}primary), 0.2);
  }

  &:checked {
    ~ label {
      outline: 2px solid var(--#{$prefix}primary);
      box-shadow: var(--#{$prefix}shadow-hover) HEXToRGBA(var(--#{$prefix}primary), 0.2);
    }
  }

  &:disabled ~ label,
  &.disabled ~ label {
    opacity: 0.33;
    pointer-events: none;
  }
}

form {
  > .content {
    padding: 24px 0;

    > fieldset {
      border: none;

      > ul {
        @include unstyled-list;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
        grid-auto-rows: 1fr;
        gap: 12px;

        > li {
          > input {
            @include input;
          }

          > label {
            > .icon {
              flex: 0 0 auto;
              font-size: 24px;
              opacity: 0.2;
              margin-bottom: 4px;
            }

            > span {
              font-size: var(--#{$prefix}font-size-xs);
            }

            > .small {
              font-size: var(--#{$prefix}font-size-xxs);
            }
          }
        }
      }
    }
  }

  > footer {
    display: flex;
    flex-direction: column;
    gap: 16px;

    > a,
    > button {
      width: 100%;
    }
  }

  @media (width >= map.get($grid-breakpoints, md)) {
    .content {
      > fieldset > ul {
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
        gap: 16px;
      }
    }

    > footer {
      flex-direction: row;
      justify-content: space-between;
      padding-top: 32px;

      > a,
      > button {
        width: unset;
      }
    }
  }
}
